import { LAYOUTS, } from '@voltmoney/types';
import { AspectRatioToken, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, ProgressIndicatorTypeTokens, ResizeModeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, TextAlignTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from "./types";
import { onCancel, onChangeDimension, onLoad } from "./actions";
import { getAppHeader } from "../../configs/config";
import { api, StoreKey } from "../../configs/api";
import sharedPropsService from "../../SharedPropsService";
import { isMobile } from "../../configs/utils";
const _isMobile = isMobile();
export const template = async (interval) => ({
    layout: {
        id: ROUTE.CHECK_LIMIT_LOADING,
        type: LAYOUTS.LIST,
        widgets: [
            { id: 'CheckLimitLoadingRootStackTop', type: WIDGET.STACK },
            { id: 'progressItem', type: WIDGET.PROGRESSINDICATOR },
            { id: 'CheckLimitLoadingRootStackBottom', type: WIDGET.STACK },
        ],
    },
    datastore: {
        CheckLimitLoadingRootStackTop: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                top: _isMobile ? SizeTypeTokens.NONE : SizeTypeTokens.MD
            },
            widgetItems: [
                { id: 'CheckLimitLoadingRootStackImage1', type: WIDGET.IMAGE },
                { id: 'CheckLimitLoadingRootStackSpace0', type: WIDGET.SPACE },
                { id: 'CheckLimitLoadingRootStackT1', type: WIDGET.TEXT },
                { id: 'CheckLimitLoadingRootStackSpace1', type: WIDGET.SPACE },
            ],
            dimensionAction: {
                routeId: ROUTE.CHECK_LIMIT_LOADING,
                type: ACTION.ON_CHANGE_DIMENSION,
                payload: {}
            }
        },
        CheckLimitLoadingRootStackBottom: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            padding: {
                bottom: SizeTypeTokens.XL
            },
            widgetItems: [
                { id: 'CheckLimitLoadingRootStackSpace3', type: WIDGET.SPACE },
                { id: 'CheckLimitLoadingRootStackBottomTextStack1', type: WIDGET.STACK },
                { id: 'CheckLimitLoadingRootStackCancelStack', type: WIDGET.STACK },
                { id: 'CheckLimitLoadingRootStackSpace2', type: WIDGET.SPACE },
                { id: 'MfcentralStack', type: WIDGET.STACK },
            ]
        },
        CheckLimitLoadingRootStackCancelStack: {
            type: StackType.row,
            justifyContent: StackJustifyContent.center,
            width: StackWidth.MATCH_PARENT,
            hide: true,
            widgetItems: [
                { id: 'CheckLimitLoadingRootStackCancelStackBtn', type: WIDGET.BUTTON }
            ]
        },
        CheckLimitLoadingRootStackCancelStackBtn: {
            type: ButtonTypeTokens.MediumGhost,
            width: ButtonWidthTypeToken.CONTENT,
            label: 'Cancel',
            fontSize: FontSizeTokens.MD,
            action: {
                routeId: ROUTE.CHECK_LIMIT_LOADING,
                type: ACTION.CANCEL,
                payload: {
                    interval: interval
                }
            }
        },
        CheckLimitLoadingRootStackBottomTextStack1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.center,
            widgetItems: [
                { id: 'CheckLimitLoadingRootStackBottomTextStack1T1', type: WIDGET.TEXT },
                { id: 'CheckLimitLoadingRootStackBottomTextStack1T2', type: WIDGET.TEXT },
            ]
        },
        CheckLimitLoadingRootStackBottomTextStack1T1: {
            label: 'This could take up to ',
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitLoadingRootStackBottomTextStack1T2: {
            label: '20 secs',
            fontSize: FontSizeTokens.XS,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "600",
            color: ColorTokens.Grey_Charcoal
        },
        MfcentralStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.center,
            widgetItems: [
                { id: 'MfcentralStackIcon1', type: WIDGET.ICON },
                { id: 'MfcentralStackSpace0', type: WIDGET.SPACE },
                { id: 'MfcentralStackT1', type: WIDGET.TEXT }
            ]
        },
        MfcentralStackT1: {
            label: '100% Safe & Secure',
            fontSize: FontSizeTokens.XXS,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "400",
            color: ColorTokens.Secondary_100
        },
        MfcentralStackIcon1: {
            name: IconTokens.VerifiedIcon1,
            size: IconSizeTokens.SM
        },
        MfcentralStackSpace0: {
            size: SizeTypeTokens.SM
        },
        progressItem: {
            activeIndex: 1,
            count: -5,
            type: ProgressIndicatorTypeTokens.LINEAR,
        },
        CheckLimitLoadingRootStackT1: {
            label: 'Hold tight! We are currently checking your portfolio credit limit.',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: "600",
            numberOfLines: 2,
            textAlign: TextAlignTokens.center,
        },
        CheckLimitLoadingRootStackImage1: {
            width: 114,
            height: 114,
            resizeMode: ResizeModeToken.COVER,
            aspectRatio: AspectRatioToken.A1_1,
            // uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/verifying_details.png',
            uri: `https://volt-images-alpha.s3.ap-south-1.amazonaws.com/verifying_details_1.svg`
        },
        CheckLimitLoadingRootStackSpace0: {
            size: SizeTypeTokens.XXXL
        },
        CheckLimitLoadingRootStackSpace1: {
            size: SizeTypeTokens.SIZE72
        },
        CheckLimitLoadingRootStackSpace2: {
            size: SizeTypeTokens.SIZE72
        },
        CheckLimitLoadingRootStackSpace3: {
            size: SizeTypeTokens.XL
        },
    }
});
export const CheckLimitLoadingMF = {
    onLoad: async ({ asyncStorage, network, navigateWithClear }, { leadId }) => {
        let interval;
        const headers = await getAppHeader();
        headers['Authorization'] = `Bearer ${await asyncStorage.get(StoreKey.LEAD_TOKEN)}`;
        // eslint-disable-next-line prefer-const
        interval = setInterval(async () => {
            const assetDetailsResponse = await network.get(`${api.getCustomerLeadsAssetDataV2}`, {
                headers: headers
            }, async () => { return; }, {
                disableDefault: true
            });
            console.log("assetDetailsResponse: ", assetDetailsResponse);
            if (assetDetailsResponse?.status === 200) {
                clearInterval(interval);
                await sharedPropsService.setCustomerLeadAssetData(assetDetailsResponse?.data);
                await navigateWithClear(ROUTE.CHECK_LIMIT_SUCCESS);
            }
            else if (assetDetailsResponse?.response?.status === 400 && assetDetailsResponse?.response?.data?.voltErrorCode === 'MF_PORTFOLIO_NOT_FOUND') {
                clearInterval(interval);
                await navigateWithClear(ROUTE.CHECK_LIMIT_NO_MF);
            }
            else if (assetDetailsResponse?.response?.status === 500) {
                clearInterval(interval);
                await navigateWithClear(ROUTE.CHECK_LIMIT_ALERT_MODAL);
            }
        }, 5000);
        return Promise.resolve(template(interval));
    },
    actions: {
        [ACTION.ON_LOAD]: onLoad,
        [ACTION.ON_CHANGE_DIMENSION]: onChangeDimension,
        [ACTION.CANCEL]: onCancel
    },
    action: {
        routeId: ROUTE.CHECK_LIMIT_LOADING,
        type: ACTION.ON_LOAD,
        payload: {}
    }
};
